import { useEffect, useMemo } from "react";
import debounce from "lodash.debounce";

const useDebouncedFilter = ({
  filterValue,
  dispatch,
  fetchAction,
  page,
  rowsPerPage,
  filterCategory,
  setPage,
  filterBranch,
  setLoader,
  resetLoaderOnFilterChange = true,
  debounceDelay = 500,
}) => {
  const debouncedFetch = useMemo(() =>
    debounce(async (name, page, rowsPerPage, category, branchId) => {
      try {
        await dispatch(
          fetchAction(
          page + 1,
           rowsPerPage,
            name,
             category,
             branchId
            ));
        if (typeof setLoader === "function") setLoader(true);
      } catch (error) {
        console.error("Error in debouncedFetch:", error);
      }
    }, debounceDelay)
  , [dispatch, fetchAction, rowsPerPage, debounceDelay]);

  useEffect(() => {
    if (resetLoaderOnFilterChange && typeof setLoader === "function") {
      setLoader(false);
    }

    debouncedFetch(filterValue, page, rowsPerPage, filterCategory, filterBranch);

    return () => {
      debouncedFetch.cancel();
    };
  }, [
    filterValue,
    page,
    rowsPerPage,
    filterCategory,
    filterBranch,
    debouncedFetch,
    resetLoaderOnFilterChange,
    setLoader,
  ]);
};

export default useDebouncedFilter;
